import { Navigate, Route, Routes } from 'react-router-dom';
import FormContext from 'src/hooks/useFormContext';
import RolesContext from 'src/hooks/useRoles';
import SemestersContext from 'src/hooks/useSemesters';
import FormPage from 'src/pages/Student/StudentForms/FormPage/FormPage';
import SubjectsContext from 'src/hooks/useSubjects';
import SupervisorPage from 'src/pages/Teacher/TeacherClass/SupervisorPage/SupervisorPage';
import PrivacyPolicyPage from 'src/pages/Main/PrivacyPolicy/PrivacyPolicyPage';
import AdminFormEditor from '../pages/AdminForms/AdminFormEditor/AdminFormEditor';
import AdminForms from '../pages/AdminForms/AdminForms';
import UsersContext from '../../../hooks/useUsers';
import AdminSubjects from '../AdminSubjects/AdminSubjects';
import AdminPage from '../AdminPage/AdminPage';
import User from '../pages/AdminUsers/User/User';
import Users from '../pages/AdminUsers/Users';
import AdminSemesters from '../pages/AdminSemesters/AdminSemesters';
import AdminSemester from '../pages/AdminSemesters/AdminSemester/AdminSemester';
import AdminClass from '../pages/AdminClass/AdminClass';

const AdminRouter = () => (
  <FormContext.Provider>
    <SubjectsContext.Provider>
      <UsersContext.Provider>
        <RolesContext.Provider>
          <SemestersContext.Provider>
            <Routes>
              <Route path="" element={<AdminPage />} />
              <Route path="forms">
                <Route path="create" element={<AdminFormEditor />} />
                <Route path="edit/:formId" element={<AdminFormEditor />} />
                <Route index element={<AdminForms />} />
              </Route>
              <Route path="users">
                <Route index element={<Users />} />
                <Route path=":userId" element={<User />} />
              </Route>
              <Route path="subjects" element={<AdminSubjects />} />
              <Route path="semesters">
                <Route index element={<AdminSemesters />} />
                <Route path=":semesterId" element={<AdminSemester />} />
              </Route>
              <Route path="class">
                <Route path=":classId">
                  <Route index element={<AdminClass />} />
                  <Route path="advisor/:userId" element={<SupervisorPage />} />
                  <Route
                    path="form/:formId/assignment/:assignmentId"
                    element={<FormPage canDeliver />}
                  />
                </Route>
              </Route>
              <Route path="privacy-policy" element={<PrivacyPolicyPage />} />
            </Routes>
          </SemestersContext.Provider>
        </RolesContext.Provider>
      </UsersContext.Provider>
    </SubjectsContext.Provider>
  </FormContext.Provider>
);

export default AdminRouter;
